import * as React from 'react';

import { Title } from '../AddPostFormFields';
import * as s from './AddPostForm.css';

export interface IAddBlogPostFormParams {
  title: string;
}

/**
 * Форма добавления/редактирования поста блога
 */
export const AddBlogPostForm = ({ title }: IAddBlogPostFormParams) => {
  const titleProps = {
    value: title,
    errorMessage: '',
    disabled: false,
    required: true,
    onChange: () => {},
  };

  return (
    <div className={s['wrapper']}>
      <Title {...titleProps} />
    </div>
  );
};
